import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { CardValue, Loadable, CurrencyValue } from "components/support";

import "./summary-card.css";

class SummaryCard extends Component {
  revenuePercentage() {
    const { value, revenues } = this.props;

    if (revenues === 0) {
      return 0;
    }
    const perCent = parseInt(value, 10) / parseInt(revenues, 10);
    return (perCent * 100).toFixed(2).toString();
  }

  render() {
    const { loading, label, value, revenues } = this.props;

    return (
      <div className="summary-card">
        <Paper elevation={1} className="mb-md pv-sm text-center">
          <Loadable loading={loading}>
            <Typography type="headline">{label}</Typography>
            <CardValue fit positive={value > 0}>
              <CurrencyValue value={parseInt(value, 10)} type="money" />
              {revenues && (
                <span className="revenue-percentage">
                  ({this.revenuePercentage()}%)
                </span>
              )}
            </CardValue>
          </Loadable>
        </Paper>
      </div>
    );
  }
}

export default SummaryCard;



// WEBPACK FOOTER //
// ./src/components/app/management/devolution-sellable-report/summary-card/index.jsx